export default {
  ROUTE_HOME: 'cof/home'
}



// WEBPACK FOOTER //
// ./src/constants/pa/dadosEstado/financeiro.js